<template>
	<bernstein-layout>
		<form @submit.prevent="submit">
			<div class="flex flex-row justify-start py-2">
				<div>
					<jet-button
						class="rounded font-bold text-white"
						:class="{ 'opacity-25': form.processing }"
						:disabled="form.processing"
					>
						Create Stock List<br />
						for Transport
					</jet-button>
				</div>
				<Link
					v-if="stocks.prev_page_url"
					class="m-2 rounded bg-gray-300 px-2 py-2"
					:href="stocks.prev_page_url"
					>Previous Page
				</Link>
				<Link
					v-if="stocks.next_page_url"
					class="m-2 rounded bg-gray-300 px-2 py-2"
					:href="stocks.next_page_url"
					>Next Page
				</Link>
			</div>
			<pagination class="mt-10" :links="stocks.links" />
			<!-- {{ stocks.data }} -->
			<!-- {{stocks.next_page_url}} -->
			<!-- <pagination class="mt-10" :links="stocks.links" /> -->

			<div class="flex flex-col overscroll-x-contain">
				<Table
					:filters="queryBuilderProps.filters"
					:search="queryBuilderProps.search"
					:columns="queryBuilderProps.columns"
					:on-update="setQueryBuilder"
					:meta="stocks"
					class="relative w-full border"
				>
					<template #head>
						<tr
							class="sticky border-b border-gray-400 bg-gray-300 py-2 font-bold text-gray-900"
						>
							<th>Selection</th>
							<!-- <td v-show="showColumn('manufacturerId')">S.N.</td> -->
							<!-- <th v-show="showColumn('updated_at')" @click.prevent="sortBy('stock_updatedAt')">Last updated At</th> -->
							<!-- @click.prevent="sortBy('manufacturerId')" -->
							<th
								class="sticky top-0 table-cell border-r border-green-200"
								v-show="showColumn('manufacturerId')"
							>
								Manufacturer
							</th>
							<!-- @click.prevent="sortBy('itemId')" -->
							<th
								class="sticky top-0 table-cell border-r border-green-200"
								v-show="showColumn('itemId')"
							>
								itemId
							</th>
							<!-- Variation id  -->
							<!-- @click.prevent="sortBy('plenty_id')" -->
							<th
								class="sticky top-0 table-cell border-r border-green-200"
								v-show="showColumn('variation_id')"
							>
								variationId
							</th>
							<th
								class="sticky top-0 table-cell border-r border-green-200"
								v-show="showColumn('isActive')"
							>
								isActive
							</th>
							<th
								class="sticky top-0 table-cell border-r border-green-200"
								v-show="showColumn('number')"
							>
								Article
							</th>
							<th
								class="sticky top-0 table-cell border-r border-green-200"
								v-show="showColumn('imageId')"
							>
								Image
							</th>
							<!-- <th v-show="showColumn('warehosue.name')" @click.prevent="sortBy('warehouseId')">Warehouse</th> -->
							<th
								class="sticky top-0 table-cell border-r border-green-200"
								v-show="showColumn('stock_physical')"
								@click.prevent="sortBy('total_stock_physical')"
							>
								<span class="flex flex-row space-x-2">
									<span class="px-2"> Total Physical</span>
									<!-- upward sorting -->
									<svg
										v-if="params.sort == 'total_stock_physical'"
										class="h-8 w-8 text-red-500"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										stroke-width="2"
										stroke="currentColor"
										fill="none"
										stroke-linecap="round"
										stroke-linejoin="round"
									>
										<path stroke="none" d="M0 0h24v24H0z" />
										<line x1="4" y1="6" x2="11" y2="6" />
										<line x1="4" y1="12" x2="11" y2="12" />
										<line x1="4" y1="18" x2="13" y2="18" />
										<polyline points="15 9 18 6 21 9" />
										<line x1="18" y1="6" x2="18" y2="18" />
									</svg>

									<!-- from up to down icon  -->
									<svg
										v-if="params.sort == '-total_stock_physical'"
										class="h-8 w-8 text-red-500"
										fill="none"
										viewBox="0 0 24 24"
										stroke="currentColor"
									>
										<path
											stroke-linecap="round"
											stroke-linejoin="round"
											stroke-width="2"
											d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4"
										/>
									</svg>
								</span>
							</th>
							<th
								class="sticky top-0 table-cell border-r border-green-200"
								v-show="showColumn('stock_net')"
								@click.prevent="sortBy('total_stock_net')"
							>
								<span class="flex flex-row space-x-2">
									<span class="px-2">Total Net </span>
									<!-- upward sorting -->
									<svg
										v-if="params.sort == 'total_stock_net'"
										class="h-8 w-8 text-red-500"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										stroke-width="2"
										stroke="currentColor"
										fill="none"
										stroke-linecap="round"
										stroke-linejoin="round"
									>
										<path stroke="none" d="M0 0h24v24H0z" />
										<line x1="4" y1="6" x2="11" y2="6" />
										<line x1="4" y1="12" x2="11" y2="12" />
										<line x1="4" y1="18" x2="13" y2="18" />
										<polyline points="15 9 18 6 21 9" />
										<line x1="18" y1="6" x2="18" y2="18" />
									</svg>

									<!-- from up to down icon  -->
									<svg
										v-if="params.sort == '-total_stock_net'"
										class="h-8 w-8 text-red-500"
										fill="none"
										viewBox="0 0 24 24"
										stroke="currentColor"
									>
										<path
											stroke-linecap="round"
											stroke-linejoin="round"
											stroke-width="2"
											d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4"
										/>
									</svg>
								</span>
							</th>
							<!-- //floersheim  -->
							<th
								class="sticky top-0 table-cell border-r border-green-200"
								v-show="showColumn('floersheim')"
								@click.prevent="sortBy('floersheim_physical')"
							>
								<span class="flex flex-row space-x-2">
									<span class="px-2"> Floersheim Physical</span>
									<!-- upward sorting -->
									<svg
										v-if="params.sort == 'floersheim_physical'"
										class="h-8 w-8 text-red-500"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										stroke-width="2"
										stroke="currentColor"
										fill="none"
										stroke-linecap="round"
										stroke-linejoin="round"
									>
										<path stroke="none" d="M0 0h24v24H0z" />
										<line x1="4" y1="6" x2="11" y2="6" />
										<line x1="4" y1="12" x2="11" y2="12" />
										<line x1="4" y1="18" x2="13" y2="18" />
										<polyline points="15 9 18 6 21 9" />
										<line x1="18" y1="6" x2="18" y2="18" />
									</svg>

									<!-- from up to down icon  -->
									<svg
										v-if="params.sort == '-floersheim_physical'"
										class="h-8 w-8 text-red-500"
										fill="none"
										viewBox="0 0 24 24"
										stroke="currentColor"
									>
										<path
											stroke-linecap="round"
											stroke-linejoin="round"
											stroke-width="2"
											d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4"
										/>
									</svg>
								</span>
							</th>
							<th
								class="sticky top-0 table-cell border-r border-green-200"
								v-show="showColumn('floersheim')"
								@click.prevent="sortBy('floersheim_net')"
							>
								<!-- Floersheim Net -->
								<span class="flex flex-row space-x-2">
									<span class="px-2">Floersheim Net </span>
									<!-- upward sorting -->
									<svg
										v-if="params.sort == 'floersheim_net'"
										class="h-8 w-8 text-red-500"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										stroke-width="2"
										stroke="currentColor"
										fill="none"
										stroke-linecap="round"
										stroke-linejoin="round"
									>
										<path stroke="none" d="M0 0h24v24H0z" />
										<line x1="4" y1="6" x2="11" y2="6" />
										<line x1="4" y1="12" x2="11" y2="12" />
										<line x1="4" y1="18" x2="13" y2="18" />
										<polyline points="15 9 18 6 21 9" />
										<line x1="18" y1="6" x2="18" y2="18" />
									</svg>

									<!-- from up to down icon  -->
									<svg
										v-if="params.sort == '-floersheim_net'"
										class="h-8 w-8 text-red-500"
										fill="none"
										viewBox="0 0 24 24"
										stroke="currentColor"
									>
										<path
											stroke-linecap="round"
											stroke-linejoin="round"
											stroke-width="2"
											d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4"
										/>
									</svg>
								</span>
							</th>
							<!-- 'hochheim_physical','hochheim_net' -->
							<th
								class="sticky top-0 table-cell border-r border-green-200"
								v-show="showColumn('hochheim')"
								@click.prevent="sortBy('hochheim_physical')"
							>
								<!-- Hochheim Physical Here comes arrow up and down  -->
								<span class="flex flex-row space-x-2">
									<span class="px-2"> Hochheim Physical</span>
									<!-- upward sorting -->
									<svg
										v-if="params.sort == 'hochheim_physical'"
										class="h-8 w-8 text-red-500"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										stroke-width="2"
										stroke="currentColor"
										fill="none"
										stroke-linecap="round"
										stroke-linejoin="round"
									>
										<path stroke="none" d="M0 0h24v24H0z" />
										<line x1="4" y1="6" x2="11" y2="6" />
										<line x1="4" y1="12" x2="11" y2="12" />
										<line x1="4" y1="18" x2="13" y2="18" />
										<polyline points="15 9 18 6 21 9" />
										<line x1="18" y1="6" x2="18" y2="18" />
									</svg>

									<!-- from up to down icon  -->
									<svg
										v-if="params.sort == '-hochheim_physical'"
										class="h-8 w-8 text-red-500"
										fill="none"
										viewBox="0 0 24 24"
										stroke="currentColor"
									>
										<path
											stroke-linecap="round"
											stroke-linejoin="round"
											stroke-width="2"
											d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4"
										/>
									</svg>
								</span>
							</th>
							<th
								class="sticky top-0 table-cell border-r border-green-200"
								v-show="showColumn('hochheim')"
								@click.prevent="sortBy('hochheim_net')"
							>
								<!-- Hochheim Net arrow up and down  -->
								<span class="flex flex-row space-x-2">
									<span class="px-2">Hochheim Net </span>
									<!-- upward sorting -->
									<svg
										v-if="params.sort == 'hochheim_net'"
										class="h-8 w-8 text-red-500"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										stroke-width="2"
										stroke="currentColor"
										fill="none"
										stroke-linecap="round"
										stroke-linejoin="round"
									>
										<path stroke="none" d="M0 0h24v24H0z" />
										<line x1="4" y1="6" x2="11" y2="6" />
										<line x1="4" y1="12" x2="11" y2="12" />
										<line x1="4" y1="18" x2="13" y2="18" />
										<polyline points="15 9 18 6 21 9" />
										<line x1="18" y1="6" x2="18" y2="18" />
									</svg>

									<!-- from up to down icon  -->
									<svg
										v-if="params.sort == '-hochheim_net'"
										class="h-8 w-8 text-red-500"
										fill="none"
										viewBox="0 0 24 24"
										stroke="currentColor"
									>
										<path
											stroke-linecap="round"
											stroke-linejoin="round"
											stroke-width="2"
											d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4"
										/>
									</svg>
								</span>
							</th>
							<!-- 'hochheim_physical','hochheim_net' -->
							<th
								class="sticky top-0 table-cell border-r border-green-200"
								v-show="showColumn('keramag')"
								@click.prevent="sortBy('keramag_physical')"
							>
								<!-- Keramag Physical here starts the arrow up and down -->
								<span class="flex flex-row space-x-2">
									<span class="px-2"> Keramag Physical</span>
									<!-- upward sorting -->
									<svg
										v-if="params.sort == 'keramag_physical'"
										class="h-8 w-8 text-red-500"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										stroke-width="2"
										stroke="currentColor"
										fill="none"
										stroke-linecap="round"
										stroke-linejoin="round"
									>
										<path stroke="none" d="M0 0h24v24H0z" />
										<line x1="4" y1="6" x2="11" y2="6" />
										<line x1="4" y1="12" x2="11" y2="12" />
										<line x1="4" y1="18" x2="13" y2="18" />
										<polyline points="15 9 18 6 21 9" />
										<line x1="18" y1="6" x2="18" y2="18" />
									</svg>

									<!-- from up to down icon  -->
									<svg
										v-if="params.sort == '-keramag_physical'"
										class="h-8 w-8 text-red-500"
										fill="none"
										viewBox="0 0 24 24"
										stroke="currentColor"
									>
										<path
											stroke-linecap="round"
											stroke-linejoin="round"
											stroke-width="2"
											d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4"
										/>
									</svg>
								</span>
							</th>
							<th
								class="sticky top-0 table-cell border-r border-green-200"
								v-show="showColumn('keramag')"
								@click.prevent="sortBy('keramag_net')"
							>
								<span class="flex flex-row space-x-2">
									<span class="px-2">Keramag Net </span>
									<!-- upward sorting -->
									<svg
										v-if="params.sort == 'keramag_net'"
										class="h-8 w-8 text-red-500"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										stroke-width="2"
										stroke="currentColor"
										fill="none"
										stroke-linecap="round"
										stroke-linejoin="round"
									>
										<path stroke="none" d="M0 0h24v24H0z" />
										<line x1="4" y1="6" x2="11" y2="6" />
										<line x1="4" y1="12" x2="11" y2="12" />
										<line x1="4" y1="18" x2="13" y2="18" />
										<polyline points="15 9 18 6 21 9" />
										<line x1="18" y1="6" x2="18" y2="18" />
									</svg>

									<!-- from up to down icon  -->
									<svg
										v-if="params.sort == '-keramag_net'"
										class="h-8 w-8 text-red-500"
										fill="none"
										viewBox="0 0 24 24"
										stroke="currentColor"
									>
										<path
											stroke-linecap="round"
											stroke-linejoin="round"
											stroke-width="2"
											d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4"
										/>
									</svg>
								</span>
							</th>
							<!-- 'not found' -->

							<!-- <th v-show="showColumn('notfound')" @click.prevent="sortBy('notFound_physical')">Not found Physical</th>
					<th v-show="showColumn('notfound')" @click.prevent="sortBy('notFound_net')">Not found Net</th>
				-->
							<!-- 'cli_bernstein_physical','cli_bernstein_net' -->
							<th
								class="sticky top-0 table-cell border-r border-green-200"
								v-show="showColumn('cli_bernstein')"
								@click.prevent="sortBy('cli_bernstein_physical')"
							>
								<!-- cli_bernstein_physical Physical here starts the arrow up and down -->
								<span class="flex flex-row space-x-2">
									<span class="px-2"> Cli Physical</span>
									<!-- upward sorting -->
									<svg
										v-if="params.sort == 'cli_bernstein_physical'"
										class="h-8 w-8 text-red-500"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										stroke-width="2"
										stroke="currentColor"
										fill="none"
										stroke-linecap="round"
										stroke-linejoin="round"
									>
										<path stroke="none" d="M0 0h24v24H0z" />
										<line x1="4" y1="6" x2="11" y2="6" />
										<line x1="4" y1="12" x2="11" y2="12" />
										<line x1="4" y1="18" x2="13" y2="18" />
										<polyline points="15 9 18 6 21 9" />
										<line x1="18" y1="6" x2="18" y2="18" />
									</svg>

									<!-- from up to down icon  -->
									<svg
										v-if="params.sort == '-cli_bernstein_physical'"
										class="h-8 w-8 text-red-500"
										fill="none"
										viewBox="0 0 24 24"
										stroke="currentColor"
									>
										<path
											stroke-linecap="round"
											stroke-linejoin="round"
											stroke-width="2"
											d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4"
										/>
									</svg>
								</span>
							</th>
							<th
								class="sticky top-0 table-cell border-r border-green-200"
								v-show="showColumn('cli_bernstein')"
								@click.prevent="sortBy('cli_bernstein_net')"
							>
								<span class="flex flex-row space-x-2">
									<span class="px-2">Cli Net </span>
									<!-- upward sorting -->
									<svg
										v-if="params.sort == 'cli_bernstein_net'"
										class="h-8 w-8 text-red-500"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										stroke-width="2"
										stroke="currentColor"
										fill="none"
										stroke-linecap="round"
										stroke-linejoin="round"
									>
										<path stroke="none" d="M0 0h24v24H0z" />
										<line x1="4" y1="6" x2="11" y2="6" />
										<line x1="4" y1="12" x2="11" y2="12" />
										<line x1="4" y1="18" x2="13" y2="18" />
										<polyline points="15 9 18 6 21 9" />
										<line x1="18" y1="6" x2="18" y2="18" />
									</svg>

									<!-- from up to down icon  -->
									<svg
										v-if="params.sort == '-cli_bernstein_net'"
										class="h-8 w-8 text-red-500"
										fill="none"
										viewBox="0 0 24 24"
										stroke="currentColor"
									>
										<path
											stroke-linecap="round"
											stroke-linejoin="round"
											stroke-width="2"
											d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4"
										/>
									</svg>
								</span>
							</th>
						</tr>
					</template>

					<template #body>
						<tr
							v-for="(stock, stockIndx) in stocks.data"
							id="table_row"
							:key="stockIndx"
							:class="[{ 'bg-gray-100': stockIndx % 2 == 0 }, p - 1]"
						>
							<td class="sticky top-0 table-cell border-r border-green-200">
								<div class="px-2 py-2">
									<input
										type="checkbox"
										id="stockIndx"
										name="stockIndx"
										value="stockIndx"
										class="rounded border-2 border-gray-900 p-6 text-indigo-600 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
										v-model="selected"
										@change="updateSelected(stock)"
									/>
								</div>
								<!-- <jet-checkbox
									name="stockSelection"
									id="stockSelection"
									v-model:checked="test"
									class="m-2 p-2"
								/> -->
							</td>
							<!-- <td v-show="showColumn('manufacturerId')">{{ stock.manufactur.name }}</td> -->
							<!-- <td v-show="showColumn('updated_at')">{{ stock.stock_updatedAt}}</td>  -->
							<td
								class="sticky top-0 table-cell border-r border-green-200"
								v-if="stock.manufacturer"
								v-show="showColumn('manufacturerId')"
							>
								{{ stock.manufacturer.name }}
							</td>
							<td
								class="sticky top-0 table-cell border-r border-green-200"
								v-else
							></td>
							<td
								class="sticky top-0 table-cell border-r border-green-200"
								v-show="showColumn('itemId')"
							>
								{{ stock.itemId }}
							</td>
							<td
								class="sticky top-0 table-cell border-r border-green-200"
								v-show="showColumn('variation_id')"
							>
								{{ stock.plenty_id }}
							</td>
							<!-- //isActive -->
							<td
								class="sticky top-0 table-cell border-r border-green-200"
								v-if="stock.variation"
								v-show="showColumn('isActive')"
							>
								{{ stock.variation.isActive }}
							</td>
							<td
								class="sticky top-0 table-cell border-r border-green-200"
								v-else
							></td>
							<td
								class="sticky top-0 table-cell border-r border-green-200"
								v-if="stock.variation"
								v-show="showColumn('number')"
							>
								{{ stock.variation.number }}
							</td>
							<td
								class="sticky top-0 table-cell border-r border-green-200"
								v-else
							></td>
							<td
								class="sticky top-0 table-cell border-r border-green-200"
								v-if="stock.image"
								v-show="showColumn('imageId')"
							>
								<img
									v-if="stock.image[0]"
									:src="stock.image[0].urlPreview"
									class="max-w-16 max-h-16 object-fill"
									@click="openModal(stock.image[0])"
								/>
							</td>
							<td
								class="sticky top-0 table-cell border-r border-green-200"
								v-else
							></td>
							<!-- <td v-show="showColumn('warehosue.name')">{{ stock.warehouse.name}}</td> -->
							<td
								class="sticky top-0 table-cell border-r border-green-200"
								v-show="showColumn('stock_physical')"
							>
								{{ stock.total_stock_physical }}
							</td>
							<td
								class="sticky top-0 table-cell border-r border-green-200"
								v-show="showColumn('stock_net')"
							>
								{{ stock.total_stock_net }}
							</td>
							<!-- floersheim_net -->
							<td
								:class="
									this.showColorStock(
										4,
										stock.floersheim_net,
										stock.variation.mainWarehouseId
									)
								"
								v-show="showColumn('floersheim')"
							>
								{{ stock.floersheim_physical }}
							</td>
							<!-- Here is the floersheim_net -->
							<td
								:class="
									this.showColorStock(
										4,
										stock.floersheim_net,
										stock.variation.mainWarehouseId
									)
								"
								v-show="showColumn('floersheim')"
							>
								{{ stock.floersheim_net }}
							</td>
							<!-- 'hochheim_physical','hochheim_net' -->
							<td
								:class="
									this.showColorStock(
										17,
										stock.hochheim_net,
										stock.variation.mainWarehouseId
									)
								"
								v-show="showColumn('hochheim')"
							>
								{{ stock.hochheim_physical }}
							</td>
							<td
								:class="
									this.showColorStock(
										17,
										stock.hochheim_net,
										stock.variation.mainWarehouseId
									)
								"
								v-show="showColumn('hochheim')"
							>
								{{ stock.hochheim_net }}
							</td>
							<!-- Keramag  -->
							<td
								:class="
									this.showColorStock(
										25,
										stock.keramag_net,
										stock.variation.mainWarehouseId
									)
								"
								v-show="showColumn('keramag')"
							>
								{{ stock.keramag_physical }}
							</td>
							<td
								:class="
									this.showColorStock(
										25,
										stock.keramag_net,
										stock.variation.mainWarehouseId
									)
								"
								v-show="showColumn('keramag')"
							>
								{{ stock.keramag_net }}
							</td>

							<!-- Not found   -->
							<!-- <td v-show="showColumn('keramag')">{{ stock.keramag_physical}}</td>
					<td v-show="showColumn('keramag')">{{ stock.keramag_net }}</td> -->
							<!-- notFound_physical -->
							<!-- <td v-show="showColumn('notfound')">{{ stock.notFound_physical}}</td>
					<td v-show="showColumn('notfound')">{{ stock.notFound_net }}</td>
			-->
							<!-- Cli bernstein  -->
							<td
								:class="
									this.showColorStock(
										40,
										stock.cli_bernstein_net,
										stock.variation.mainWarehouseId
									)
								"
								v-show="showColumn('cli_bernstein')"
							>
								{{ stock.cli_bernstein_physical }}
							</td>
							<td
								:class="
									this.showColorStock(
										40,
										stock.cli_bernstein_net,
										stock.variation.mainWarehouseId
									)
								"
								v-show="showColumn('cli_bernstein')"
							>
								{{ stock.cli_bernstein_net }}
							</td>
						</tr>
					</template>
				</Table>
			</div>
		</form>
		<div class="flex flex-row justify-between py-2">
			<Link
				v-if="stocks.prev_page_url"
				class="m-2 rounded bg-gray-300 px-2 py-2"
				:href="stocks.prev_page_url"
				>Previous Page
			</Link>
			<Link
				v-if="stocks.next_page_url"
				class="m-2 rounded bg-gray-300 px-2 py-2"
				:href="stocks.next_page_url"
				>Next Page
			</Link>
		</div>
		<!-- here starts the modal  -->
		<TransitionRoot appear :show="isOpen" as="template">
			<Dialog as="div" @close="closeModal">
				<div class="fixed inset-0 z-10 overflow-y-auto">
					<div class="min-h-screen px-4 text-center">
						<TransitionChild
							as="template"
							enter="duration-300 ease-out"
							enter-from="opacity-0"
							enter-to="opacity-100"
							leave="duration-200 ease-in"
							leave-from="opacity-100"
							leave-to="opacity-0"
						>
							<DialogOverlay class="fixed inset-0" />
						</TransitionChild>

						<span class="inline-block h-screen align-middle" aria-hidden="true">
							&#8203;
						</span>

						<TransitionChild
							as="template"
							enter="duration-300 ease-out"
							enter-from="opacity-0 scale-95"
							enter-to="opacity-100 scale-100"
							leave="duration-200 ease-in"
							leave-from="opacity-100 scale-100"
							leave-to="opacity-0 scale-95"
						>
							<div
								class="my-8 inline-block w-full max-w-md transform overflow-hidden rounded-2xl bg-gray-50 bg-white p-6 text-left align-middle shadow-xl transition-all"
							>
								<!-- <DialogTitle
                      as="h3"
                      class="text-lg font-medium leading-6 text-gray-900"
                    >
                      Payment successful
                    </DialogTitle> -->
								<!-- <div class="mt-2"> -->
								<!-- <div class="text-sm text-gray-500">
                        Your payment has been successfully submitted. We’ve sent you
                        an email with all of the details of your order.
                        
                      </div> -->

								<img :src="picUrl" class="max-h-60 w-full object-cover" />

								<!-- </div> -->

								<div class="mr-0 mt-4 text-right">
									<button
										type="button"
										class="justify-right inline-flex rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-indigo-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
										@click="closeModal"
									>
										Schließen
									</button>
								</div>
							</div>
						</TransitionChild>
					</div>
				</div>
			</Dialog>
		</TransitionRoot>
		<!-- here ends the modal  -->
		<!-- {{ stocks }} -->
	</bernstein-layout>
</template>
<script>
import { Head, Link } from "@inertiajs/inertia-vue3";
import BernsteinLayout from "@/Layouts/BernsteinLayout.vue";
import JetCheckbox from "@/Jetstream/Checkbox.vue";
import JetLabel from "@/Jetstream/Label.vue";
import JetButton from "@/Jetstream/Button.vue";
import {
	InteractsWithQueryBuilder,
	Tailwind2,
} from "@protonemedia/inertiajs-tables-laravel-query-builder";
import { ref } from "vue";
import {
	TransitionRoot,
	TransitionChild,
	Dialog,
	DialogOverlay,
	DialogTitle,
} from "@headlessui/vue";

export default {
	mixins: [InteractsWithQueryBuilder],
	components: {
		BernsteinLayout,
		Head,
		Link,
		Table: Tailwind2.Table,
		// Modal components
		TransitionRoot,
		TransitionChild,
		Dialog,
		DialogOverlay,
		DialogTitle,
		JetCheckbox,
		JetLabel,
		JetButton,
	},
	props: {
		stocks: Array,
		params: Array,
	},
	setup() {
		const isOpen = ref(false);
		const picUrl = ref("");

		return {
			isOpen,
			picUrl,
			closeModal() {
				isOpen.value = false;
			},
			openModal(image) {
				isOpen.value = true;
				console.log("test");
				console.log(image.url);
				if (image.url != "") {
					picUrl.value = image.url;
				}
				console.log(picUrl);
			},
		};
	},
	data() {
		return {
			form: this.$inertia.form({
				processing: false,
				selected: {},
				// SelectedVariations: "",
				// floersheim_physical: "",
				// floersheim_net: "",
				// keramag_physical: "",
				// keramag_net: "",
				// hochheim_physical: "",
				// hochheim_net: "",
			}),
		};
	},

	methods: {
		updateSelected: function (stock) {
			console.log(stock);
			let _required_stock = {};
			_required_stock["itemId"] = stock["itemId"];
			_required_stock["plenty_id"] = stock["plenty_id"];
			_required_stock["variationId"] = stock["plenty_id"];
			_required_stock["floersheim_physical"] = stock["floersheim_physical"];
			_required_stock["floersheim_net"] = stock["floersheim_net"];
			_required_stock["keramag_physical"] = stock["keramag_physical"];
			_required_stock["keramag_net"] = stock["keramag_net"];
			_required_stock["hochheim_physical"] = stock["hochheim_physical"];
			_required_stock["hochheim_net"] = stock["hochheim_net"];
			_required_stock["cli_bernstein_physical"] =
				stock["cli_bernstein_physical"];
			_required_stock["cli_bernstein_net"] = stock["cli_bernstein_net"];
			_required_stock["name"] = stock["variation"]["number"];
			_required_stock["mainWarehouseId"] =
				stock["variation"]["mainWarehouseId"];
			console.log(_required_stock);
			// console.log(stock.plenty_id);
			let plentyId = stock.plenty_id;
			let obj_keys = Object.keys(this.form.selected);
			// console.log(obj_keys);
			let key_exists = obj_keys.includes(plentyId);
			// console.log(key_exists);
			if (key_exists) {
				delete this.form.selected[plentyId];
			} else {
				// this.form.selected[plentyId] = stock;
				this.form.selected[plentyId] = _required_stock;
				// console.log(this.form.selected);
			}

			// this.form.selected[stock.plenty_id] = stock;
			// console.log(this.form.selected);
		},
		submit() {
			this.form.processing = true;
			// console.log("submitting ");
			this.form.post("/stocks/create-transport-list", {
				// onFinish: () => this.form.reset("variationId", "variationId"),
			});
		},
		changeImageWhen: function (imageArray, state) {
			if (state === "over") {
				// return imageArray.url;
				this.hovered = true;
			}
			if (state === "down") {
				// return imageArray.urlPreview;
				this.hovered = false;
			}
		},
		// show red color to the cells where the stocks is very less
		showColorStock: function (warehouseId, stockCount, mainWarehouseId) {
			if (warehouseId == mainWarehouseId) {
				if (stockCount <= 5) {
					return "top-0 border-r border-green-200 text-black-900 font-extrabold bg-red-400 hover:bg-indigo-300 table-cell";
				}
				if (stockCount > 5 && stockCount <= 10) {
					return "top-0 border-r border-green-200 text-black-900 font-extrabold bg-amber-300 hover:bg-indigo-300 table-cell";
				}
				if (stockCount > 10) {
					return "top-0 border-r border-green-200 text-black-900 font-extrabold bg-green-300 hover:bg-indigo-300 table-cell";
				}
			} else {
				if (stockCount < 0) {
					return "top-0 border-r border-green-200 text-black-900 font-extrabold bg-red-400 hover:bg-indigo-300 table-cell";
				}
				if (stockCount <= 5 && stockCount > 0) {
					return "top-0 border-r border-green-200 text-black-900 font-extrabold bg-amber-300 hover:bg-indigo-300 table-cell";
				}

				if (stockCount > 5) {
					return "top-0 border-r border-green-200 text-black-900 font-extrabold bg-green-300 hover:bg-indigo-300 table-cell";
				}
			}
		},
	},
	imagePreview: function (image) {
		imgPrview = "#";
		if (image) {
			console.log(image);
			imgPrview = image.urlPreview;
		}
		//  console.log(image)
		return imgPrview;
	},
};
</script>
<style scoped>
#table_row:hover {
	background-color: rgb(192 132 252) !important;
}
.table-cell:hover {
	background-color: rgb(192 132 252) !important;
}
</style>
